
import React, { useState, useEffect } from 'react';
import { Button, Divider, Typography } from '@mui/material';
import styles from './Styles';
import FirstTab from './First_Tab';
import SSPCommonModal from '../../CommonComponents/SSPCommonModal/SSPCommonModal';
import { post } from "../../services";
import Cookies from "js-cookie";
import SecondTab from './Second_Tab';
import ThirdTab from './Third_Tab';


const PrintAssetQr = () => {
    const [activeTab, setActiveTab] = useState('asset_QR_file');
    const [rows, setRows] = useState([]);
    const [perviousRowData, setperviousRowData] = useState([]);
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [migratedAssetRowData, setmigratedAssetRowData] = useState([]);
    const id = Cookies.get("ssp_domain_id");

    const base = "https://";

    const rowFetch = async () => {
        let response = await post(
            base + "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/asset_qr_logs",
            {
                log_id: "",
                domain_id: id,
                source: "SSP",
            },
            true,
            false
        );
        if (response?.status === "success") {
            const rowsData = response?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setRows(rowsData);

        } else {
            setmessage("No Rows");
            setmodalOpener(true);
        }
    };


    const perviousRowFetch = async () => {
        let response = await post(
            base + "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/asset_qr_duplicate_logs",
            {
                log_id: "",
                domain_id: id,
                source: "SSP"
            },
            true,
            false
        );
        if (response?.status === "success") {
            const rowsData = response?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setperviousRowData(rowsData);
        } else {
            setmessage("No Rows");
            setmodalOpener(true);
        }
    };
    const migrateAssetRowFetch = async () => {
        let response = await post(
            base + "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/get_migrated_qr_logs",
            {
                domain_id: id,
                source: "SSP"

            },
            true,
            false
        );
        if (response?.status === "success") {
            const rowsData = response?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setmigratedAssetRowData(rowsData);
        } else {
            setmessage("No Rows");
            setmodalOpener(true);
        }



    }

    useEffect(() => {
        perviousRowFetch();
        migrateAssetRowFetch();
    }, []);


    useEffect(() => {
        rowFetch();
    }, []);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div style={{ height: '100%', marginTop: 50, marginLeft: 10, marginRight: 10, width: "98%" }}>
            <Typography fontWeight={'bold'}>
                Asset Management : Print Asset QR
            </Typography>
            <Divider sx={{ borderBottomWidth: 1, height: 5 }} />
            <header style={styles.tabsHeader}>
                <Button
                    style={activeTab === 'asset_QR_file' ? styles.activeTab : styles.inactiveTab}
                    onClick={() => handleTabChange('asset_QR_file')}
                >
                    Download Network / Asset tag file
                </Button>
                <Button
                    style={activeTab === 'Migrated Assets QR file' ? styles.activeTab : styles.inactiveTab}
                    onClick={() => handleTabChange("Migrated Assets QR file")}
                >
                    Download Migrated Assets QR file
                </Button>
                <Button
                    style={activeTab === 'duplicate_asset_QR_file' ? styles.activeTab : styles.inactiveTab}
                    onClick={() => handleTabChange('duplicate_asset_QR_file')}
                >
                    Download Duplicate Asset QR file
                </Button>
            </header>
            <Divider sx={{ borderBottomWidth: 1 }} />
            <div className="content">
                {activeTab === 'asset_QR_file' && <FirstTab rows={rows} rowFetch={rowFetch} />}
                {activeTab === 'duplicate_asset_QR_file' && <SecondTab row={perviousRowData} perviousRowFetch={perviousRowFetch} />}
                {activeTab === 'Migrated Assets QR file' && <ThirdTab rowData={migratedAssetRowData} perviousRowFetch={migrateAssetRowFetch} />}

            </div>

            {modalOpener && (
                <SSPCommonModal
                    open={modalOpener}
                    handleOpenClose={setmodalOpener}
                    message={message}
                />
            )}
        </div>
    );
};

export default PrintAssetQr;
